import { defineMessages } from 'react-intl';

export default defineMessages({
  emergencyModeDescription: {
    id: 'app.components.EmergencyModeForm.emergencyModeDescription',
    defaultMessage:
      'As soon as you activate emergency mode, all participants will be notified of the emergency and asked to report as soon as they receive the message and as soon as they are safe.',
  },
  reason: {
    id: 'app.components.EmergencyModeForm.reason',
    defaultMessage: 'Reason (max. 30 characters)',
  },
  route: {
    id: 'app.components.EmergencyModeForm.route',
    defaultMessage: 'Route',
  },
  maxChars: {
    id: 'app.components.EmergencyModeForm.maxChars',
    defaultMessage:
      'The text cannot have more than {maxNumberOfChars} characters.',
  },
  save: {
    id: 'app.components.EmergencyModeForm.save',
    defaultMessage: 'Enter emergency mode',
  },
  allRoutes: {
    id: 'app.components.EmergencyModeForm.allRoutes',
    defaultMessage: 'All routes',
  },
});
